@if (true) {
  <app-cards-basic [title]="'COMMON.' + language() | translate">
    <div class="position-absolute-top-right">
      <button mat-icon-button aria-label="Delete Button" class="delete-button" (click)="copyData()">
        <mat-icon><span class="material-symbols-outlined">content_copy</span></mat-icon>
      </button>
      <button mat-icon-button aria-label="Delete Button" class="delete-button" (click)="pasteData()">
        <mat-icon><span class="material-symbols-outlined">file_download</span></mat-icon>
      </button>
    </div>
    <div class="py-2">
      <mat-chip-set
        class="example-chip"
        cdkDropList
        cdkDropListOrientation="horizontal"
        (cdkDropListDropped)="drop($event)"
      >
      @for (column of displayedColumns; track column; let i = $index) {
        @if (column == 'select') {
          <mat-chip style="display: none;" cdkDrag>
            {{ column }}
          </mat-chip>
        } @else {
          <mat-chip style="margin-right: 6px" cdkDrag>
            {{ column }}
            <button matChipRemove (click)="deleteColumn(i)" aria-label="Remove column">
              <mat-icon>
                <span class="material-symbols-outlined">cancel</span>
              </mat-icon>
            </button>
          </mat-chip>
        }
      }
      </mat-chip-set>
    </div>

    <table mat-table [dataSource]="dataSource" cdkDropList (cdkDropListDropped)="dropRow($event)">
      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox (change)="$event ? toggleAllRows() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()"
                        [aria-label]="checkboxLabel()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row" >
          <mat-icon >
            <span class="material-symbols-outlined">drag_indicator</span>
          </mat-icon>
          <mat-checkbox (click)="$event.stopPropagation()"
                        (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)"
                        [aria-label]="checkboxLabel(row)">
          </mat-checkbox>
        </td>
      </ng-container>


      @for (column of displayedColumns; track column; let i = $index) {
        @if (column !== 'select') {
          <ng-container [matColumnDef]="column">
            <th mat-header-cell *matHeaderCellDef contenteditable="true" (blur)="updateHeader(i, $event)">
              {{ column }}
            </th>
            <td mat-cell *matCellDef="let row" contenteditable="true"
                (click)="$event.stopPropagation()"
                (mousedown)="$event.stopPropagation()"
                (blur)="updateCell(row, i-1, $event)">
              {{ row[i-1] }}
            </td>
          </ng-container>
        }
      }



      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" cdkDrag>
      </tr>
    </table>
    <mat-paginator [length]="dataSource.data.length"
                   [pageSizeOptions]="[20, 50, 100]"
                   showFirstLastButtons
                   aria-label="Select page of periodic elements">
    </mat-paginator>

    <div class="pt-2">
      <button mat-flat-button color="primary" class="bp-button" (click)="addColumn()">Add Column</button>
      <button mat-flat-button color="primary" class="bp-button mx-2" (click)="addRow()">Add Row</button>
      <button mat-flat-button color="primary" class="bp-button" (click)="fileInput.click()">Import CSV</button>
      <input type="file" #fileInput (change)="importCSV($event)" accept=".csv" style="display:none">
      <button mat-flat-button color="primary" class="bp-button mx-2" (click)="deleteSelectedRows()"
              [disabled]="selection.isEmpty()">Delete {{ selection.selected.length }} Selected Rows
      </button>


    </div>


  </app-cards-basic>
}
